export interface Filter {
  property: {
    name: string;
    type: string;
  };
  operator: {
    value: string;
    typesAccepted: string[];
  };
  value: string;
}

export interface FilterValue {
  property: string;
  operator: string;
  value: string;
}

export type Sort = 'asc' | 'desc';

export enum ELastDays {
  TODAY = 0,
  WEEK = 7,
  MONTH = 30,
  CUSTOM = 100,
}

export enum EDateFilter {
  LAST_DAYS = 'lastDays',
  RANGE = 'range',
}
